<template>
  <div>
    <div class="row">
      <div class="col-12 table-container ">
        <div class="mt-3">
          <LoadingSpinner v-if="loadingteam" />
          <table class="table table-striped" v-if="!loadingteam">
            <thead class="thead-dark">
              <tr>
                <th scope="col">{{ $t("lang.column.name") }}</th>
                <th scope="col">{{ $t("lang.optionlist.Sales") }}</th>
                <th scope="col" v-if="currentUser.is_agency == 1">{{ $t("lang.label.orders") }}</th>
                <th scope="col">{{ $t("lang.column.status") }}</th>
              </tr>
            </thead>
            <tbody v-if="dataUsers">

              <tr v-for="(row, key) in dataUsers" :key="key">
                <td> <!-- name -->
                  <div>Team {{ row.parent_name }} ( {{ row.group_sub }} )</div>
                  <div>
                    <img src="@/assets/images/icon_team.png" alt="file" srcset="">
                  </div>
                </td>
                <td> <!-- commercial -->
                  <div>{{ row.parent_name }} <span
                      v-if="row.parent_email && !parentDeleted(row.parent_email)">({{row.parent_email }})</span>
                    <span v-if="row.parent_email && parentDeleted(row.parent_email)">
                      <span class="badge btn-danger">
                        {{ $t("lang.label.deleted") }}
                      </span></span>
                  </div>
                </td>
                <td v-if="currentUser.is_agency == 1"> <!-- targets -->
                  <div v-if="row.targets">
                    <div v-for="(target, key) in row.targets.split(',') " :key="key">
                      <a :href="'https://app.oliverlist.com/orders/' + row.target_id" target="_blank"
                        class="text-primary cursor-pointer">
                        {{ target.split("/")[0] }}
                      </a>
                    </div>
                  </div>
                  <div v-else>
                    <button class="btn btn-success btn-primary" @click="openEngageModal(row)" type="submit">
                      {{ $t("lang.button.engage") }}
                    </button>

                  </div>
                </td>
                <td v-if="currentUser.is_agency == 1">
                  <div v-if="row.user_status_id == 3">
                    <span class="badge btn-danger">
                      {{ $t("lang.label.deleted") }}
                    </span>
                  </div>

                  <div v-else-if="
                          row.warmup_activated > 0 &&
                            warmupDays(row.warmup_date) < 15
                        ">
                    <Tooltip :text="$t('lang.general.teamwarmingup')" :width="''">
                      <span class="badge btn-warning cursor-pointer">
                        Warming-up
                      </span>
                    </Tooltip>
                    <div class="small">
                      {{ warmupDays(row.warmup_date) }}
                      / 15 {{ $t("lang.label.days") }}
                    </div>
                  </div>
                  <div v-else-if="
                          row.warmup_activated > 0 &&
                            warmupDays(row.warmup_date) >= 15 &&
                            row.targets_active > 0
                        ">
                    <Tooltip :text="$t('lang.general.teamactive')" :width="''">
                      <span class="badge btn-success cursor-pointer">
                        {{ $t("lang.appointments.active") }}
                      </span>
                    </Tooltip>
                  </div>
                </td>
                <td v-else>
                  {{ row.user_status_name }}
                </td>
              </tr>
            </tbody>
            <tbody v-else>
              <tr class="no-results-row">
                <td colspan="4">
                  <LoadingSpinner v-if="!loadingteam" />
                  <span class="font-weight-bold ft-1-5 text-center">There are no data</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <Modal :name="'engageModal'" :size="'50'" :max-width="'350'"> <!-- Modal Engage-->
      <div v-if="currentUserTeam" class="p-4 text-center" >
        <h3>Engage Team {{ currentUserTeam.parent_name }} ( {{ currentUserTeam.group_sub }} ) in a order </h3>
      </div>
      <div class=" p-6 modal-body" >
        <form @submit.prevent="saveTarget">
          <div class="form-group" >
            <label for="orderSelect">Select an order</label>
            <select class="form-control" id="orderSelect" v-model="selectedOrder" required>
              <option value="">Select...</option>
              <option v-for="order in this.targetList" :value="order.id">{{ order.name }}</option>
            </select>
          </div>
       <!-- Botones del modal -->
          <div class=" p-6  d-flex justify-content-center">
            <button type="submit" class="btn btn-primary mr-4" @click="saveTarget()">Accept</button>
            <button type="button" class="btn btn-danger " data-dismiss="modal" @click="closeModal()">Cancel</button>
          </div>
        </form>
      </div>
    </Modal>
  </div>
</template>

<script>
import { clientsService, usersService, targetsService } from "@/_services";

import { mapState } from "vuex";
import Table from "@/components/Common/Table.vue";

export default {

  computed: {
    ...mapState({
      currentUser: state => state.authentication.user,
    }),
  },

  created() {
    usersService.getSalesChild().then(result => {
      this.dataUsers = result
    });

    this.getTargetList();
  },
  data() {
    return {
      dataUsers: [],
      loadingteam: false,
      selectedOrder: null,
      targetList : [],
      currentUserTeam : null
    };
  },
  components: {
    Table
  },
  methods: {
    parentDeleted(email) {
      if (email.includes("DELETED")) {
        return true
      }
      return false;
    },
    getBadgeTargetStatus(status) {
      switch (status) {
        case "1":
          return "btn-success";
          break;
        case "2":
          return "btn-danger";
          break;
        case "3":
          return "btn-warning";
          break;
        case "4":
          return "btn-success";
          break;
        case "5":
          return "btn-secondary";
          break;
      }
    },
    warmupDays(date) {
      var date1 = new Date(date);
      var date2 = new Date();

      // To calculate the time difference of two dates
      var days = parseInt(
        (date2.getTime() - date1.getTime()) / (1000 * 3600 * 24)
      );
      return days;
    },
    openEngageModal(row){
      this.currentUserTeam = row;
      this.$modal.show("engageModal");
    },
    closeModal(){
      this.currentUserTeam = null;
      this.$modal.hide("engageModal");
    },
    saveTarget() {
      if (this.selectedOrder) {

        let dataUserTarget = {
          "target_id": this.selectedOrder,
          "target_user_status_id": this.currentUserTeam.user_status_id,
          "users":
          {
            "user_id": this.currentUserTeam.id
          }

        };

        // usersService.getSalesChild().then(result => {
        //   this.dataUsers = result
        // });
        targetsService.setUsers(dataUserTarget).then((result) => {
          usersService.getSalesChild().then(result => {
          this.dataUsers = result
        });

          if (result === "ok") {
            this.$swal({
              type: "success",
              title: this.$t("lang.label.great"),
              text: this.$t("lang.label.datasavedsuccessfully"),
              showConfirmButton: false,
              timer: 1500
            });
          } else {
            this.$swal({
              type: "warning",
              title: this.$t("lang.general.errordata"),
              text: "",
              showCancelButton: false,
            });
          }
        });
      }
      this.selectedOrder = null;
      this.closeModal();
    },
    getTargetList() {
      let data = {
        client_id: this.currentUser.client_id,
        target_status_id: [1, 3, 4],
        searchFilter: {
          "currentPage": 1,
          "cantPerPage": 25,
          "filters": null
        }
      }
      targetsService.getTargetListByClient(data).then((result) => {
        this.targetList = result.ordersStatus;

      });
    }

  }
};
</script>